import dayjs from 'dayjs'

const DEFAULT_MAX_RANGE_DAYS = 31

export const getReportMaxRangeDays = () => {
  const value = Number(process.env.VUE_APP_REPORT_MAX_RANGE_DAYS || '30')
  if (Number.isFinite(value) && value > 0) {
    return value
  }
  return DEFAULT_MAX_RANGE_DAYS
}

export const getRangeInDays = (startDate, endDate) => {
  if (!startDate || !endDate) return null

  const start = dayjs(startDate)
  const end = dayjs(endDate)

  if (!start.isValid() || !end.isValid()) {
    return null
  }

  return end.diff(start, 'day')
}

export const isRangeWithinLimit = (startDate, endDate) => {
  const diff = getRangeInDays(startDate, endDate)
  if (diff === null) return true

  return diff <= getReportMaxRangeDays()
}

export const validateReportRange = (startDate, endDate) => {
  const diff = getRangeInDays(startDate, endDate)
  if (diff === null) {
    return {
      isValid: true,
      differenceInDays: diff,
      maxRangeDays: getReportMaxRangeDays()
    }
  }

  const maxRangeDays = getReportMaxRangeDays()
  return {
    isValid: diff >= 0 && diff <= maxRangeDays,
    differenceInDays: diff,
    maxRangeDays
  }
}

export default {
  getReportMaxRangeDays,
  getRangeInDays,
  isRangeWithinLimit,
  validateReportRange
}

